export enum FilterOperatorType {
  And = 'AND',
  Or = 'OR',
}